import queryView from '../../views/ins-claim/board-static.vue';
import queryDetail from '../../views/ins-claim/claim-detail.vue';
import board from '../../views/ins-claim/claim-dash-board.vue';
import boardCase from '../../views/ins-claim/board-case.vue';
import boardPayment from '../../views/ins-claim/board-payment.vue';
import boardPayExpired from '../../views/ins-claim/board-pay-expired.vue';
import boardTimeEfficiency from '../../views/ins-claim/board-time-efficiency.vue';
var insClaimRoute = [
    {
        name: 'claimList',
        path: 'query',
        component: queryView,
    },
    {
        name: 'claimDetail',
        path: 'query-detail/:claimId',
        component: queryDetail,
        props: true,
    },
    {
        name: 'claimBoard',
        path: 'board',
        component: board,
    },
    {
        name: 'boardCase',
        path: 'board-case',
        component: boardCase,
        props: true,
    },
    {
        name: 'boardPayment',
        path: 'board-payment',
        component: boardPayment,
        props: true,
    },
    {
        name: 'boardPayExpired',
        path: 'board-pay-expired',
        component: boardPayExpired,
        props: true,
    },
    {
        name: 'boardTimeEfficiency',
        path: 'board-time-efficiency',
        component: boardTimeEfficiency,
        props: true,
    },
];
export default insClaimRoute;
